<template>
  <div class="history-block">
    <div class="history-block-title">
      {{ $tr('vacancy.preferences.settings.urlHistory.title') }}
    </div>

    <ul class="history-block-list">
      <li v-for="item in list" :key="item.id" class="history-block-item">
        <div class="history-block-text" :title="`${domain}${item.landing_url_path}`">
          <span class="history-domain">{{ domain }}</span>
          <span class="history-url">{{ item.landing_url_path }}</span>
        </div>

        <div class="history-delete" @click="handleRemoveUrl(item)">
          <icon-remove />
        </div>
      </li>
    </ul>

    <modal
      v-if="isRemoveModalVisible"
      class="history-modal"
      :has-footer="false"
      redesign
      @close="toggleRemoveModal(false)"
    >
      <div slot="header">{{ $tr('vacancy.preferences.settings.urlHistory.modalTitle') }}</div>

      <div slot="body">
        <p
          v-html="
            $tr('vacancy.preferences.settings.urlHistory.modalText', {
              url: domain + '' + (selectedUrl ? selectedUrl.landing_url_path : '')
            })
          "
        ></p>

        <div class="history-buttons">
          <vbutton :text="$tr('common.cancel')" color="grey" @click="toggleRemoveModal(false)" />

          <vbutton :text="$tr('vacancy.preferences.settings.urlHistory.btn')" @click="removeUrl" />
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Axios from 'axios';
import Modal from '@/components/Modal';

export default {
  name: 'UrlHistory',

  components: {
    Modal
  },

  props: {
    list: {
      type: Array,
      default: () => []
    },

    domain: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      isRemoveModalVisible: false,
      selectedUrl: null
    };
  },

  computed: {
    ...mapState('vacancy_new', { vacancy: 'item' })
  },

  methods: {
    handleRemoveUrl(item) {
      this.selectedUrl = item;
      this.toggleRemoveModal(true);
    },

    getUrlHistory() {
      this.$store.dispatch('vacancy/url/getHistory', {
        vacancyId: this.vacancy.id
      });
    },

    toggleRemoveModal(val) {
      this.isRemoveModalVisible = val;
      if (!val) {
        this.selectedUrl = null;
      }
    },

    removeUrl() {
      if (!this.selectedUrl) {
        return;
      }
      Axios.delete(`/v2/vacancy/url-history/${this.selectedUrl.id}`)
        .then(() => {
          return this.getUrlHistory();
        })
        .then(() => {
          this.toggleRemoveModal(false);
          this.$emit('submit');
        })
        .catch(e => {
          this.$noty.error(e && e.message ? e.message : this.$tr('common.error'));
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.history-block {
  border: 1px solid #d2d6e0;
  box-sizing: border-box;
  border-radius: 2px;

  ::v-deep {
    .history-modal.modal-mask.redesign {
      .modal-wrapper .close-icon {
        right: 11px;
        top: 14px;
        font-size: 28px;
        color: #9faab6;

        &:hover {
          color: #607182;
        }
      }
      .modal-container {
        box-sizing: border-box;
        max-width: 450px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        border-radius: 2px;
        padding: 30px 40px;
      }
      .modal-header {
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 32px;
        color: #233346;
      }

      .modal-body {
        margin: 14px 0 0;
        p {
          margin: 0;
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          color: #233346;
        }
      }
    }
  }
}

.history-block-title {
  padding: 18px 10px 12px;
  font-weight: 500;
  font-size: 15px;
  line-height: 100%;
  display: flex;
  align-items: center;
  color: #233346;
}

.history-block-list {
  list-style: none;
  padding: 0;
  max-height: 200px;
  overflow-y: auto;
}

.history-block-item {
  padding: 7px 10px 6px;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  color: #233346;
  white-space: nowrap;
  cursor: default;

  &:hover {
    background: #f4f5f7;
  }
}

.history-domain {
  white-space: nowrap;
  color: #9faab6;
}

.history-delete {
  margin-left: auto;
  color: #9faab6;
  cursor: pointer;

  &:hover {
    color: #607182;
  }
}

.history-buttons {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 25px;

  ::v-deep {
    .vbutton {
      padding: 10px 20px;
      &:not(:first-child) {
        margin-left: 10px;
      }

      &.grey {
        color: #9faab6 !important;

        &:hover {
          color: #9faab6 !important;
        }
      }
    }
  }
}

.history-block-text {
  display: inline-block;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 34px);
}
</style>
